export default __webpack_public_path__ + "static/media/volunteer-network.e813167e.png";